import { ReactComponent as PatternDefs } from '@assets/logos/pattern_defs.svg';
import Head from '@components/head';
import Header from '@components/header';
import MobileMenu from '@components/mobile_menu';
import MobileMenuContext from '@contexts/mobile_menu_context';
import { THEME } from '@helpers/style_constants';
import '@static/styles/font_styles.css';
import GlobalStyle from '@styles/global_styles';
import React, { useState } from 'react';
import { ThemeProvider } from 'styled-components';
import Footer from './footer';

/**
 *
 * @param pageName - name of the landing page (for tracking purposes)
 * @param children - Child components to inject into layout - main body of the page
 * @param location - Gatsby's modified location prop
 * @param queryData - Page query data to pass into the component (since StaticQueries can't do variables...)
 */
export default ({ pageName, children, location, queryData }: any) => {
  const [mobileMenuIsOpen, setMobileMenuIsOpen] = useState(false);
  const toggleOpen = () => {
    setMobileMenuIsOpen(!mobileMenuIsOpen);
  };

  return (
    <ThemeProvider theme={THEME}>
      <>
        <Head pageName={pageName} location={location} pageContext={queryData} />
        <GlobalStyle />
        <PatternDefs />
        <MobileMenuContext.Provider value={{ mobileMenuIsOpen, toggleOpen }}>
          <MobileMenu isOpen={mobileMenuIsOpen} toggleOpen={toggleOpen} />
          <Header location={location} />
          <main>{children}</main>
        </MobileMenuContext.Provider>
        <Footer />
      </>
    </ThemeProvider>
  );
};
